export interface AuthHashError {
	code: string | null;
	description: string | null;
}

/** Parse Supabase auth errors from the URL hash (e.g. after expired invite links). */
export function parseAuthHashError(hash: string): AuthHashError | null {
	if (!hash || hash.length < 2) return null;

	const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
	const error = params.get("error");
	const code = params.get("error_code");
	const description = params.get("error_description");

	if (!error && !code && !description) return null;

	return {
		code: code ?? error,
		description: description ? decodeURIComponent(description.replace(/\+/g, " ")) : null,
	};
}

export function getAuthHashErrorMessage(parsed: AuthHashError): {
	title: string;
	body: string;
} {
	const code = parsed.code?.toLowerCase() ?? "";

	if (code === "otp_expired" || code.includes("expired")) {
		return {
			title: "This invite link has expired",
			body: "Ask your admin to resend the invitation, then open only the newest email. Links are single-use and time-limited.",
		};
	}

	if (code === "access_denied") {
		return {
			title: "Sign-in link could not be used",
			body:
				parsed.description ??
				"The link may have already been used, expired, or opened by an email scanner. Request a fresh invite and try again.",
		};
	}

	return {
		title: "Something went wrong with the sign-in link",
		body:
			parsed.description ??
			"Try logging in with the email and password you set when you accepted your invite, or ask for a new invitation email.",
	};
}
